class ResyncType {
	static None = 1;
	static Partial = 2;
	static Full = 3;
}

export default ResyncType;